import { useFilterSalaryTypeContext } from "./filter-salary-type.context";

export function FilterSalaryType() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterSalaryTypeContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}